import axios, { AxiosResponse } from 'axios'
import { apiNode } from './api'
import {
  GetContactsDataResponse,
  ContactDataProps,
  ContactData,
} from './types/contact.interfaces'


const URL_CONTACTS = '2/contacts/v2/contacts'

export const  ContactService = {
    async getContacts({
      offset = 0,
      limit = 100,
    }: {
      offset?: number,
      limit?: number
    }): Promise<GetContactsDataResponse> {
      const response: AxiosResponse<GetContactsDataResponse> =
        await apiNode.get(`${URL_CONTACTS}`, {
          params: {
            offset,
            limit,
          },
        })
      return response?.data
    },
    async addContact({data}: {data: ContactDataProps}) {
      const response: AxiosResponse<GetContactsDataResponse> =
        await apiNode.post(`${URL_CONTACTS}`, data)
      return response?.data
    },
    async updateContact({data}: {data: ContactData}) {
      const response: AxiosResponse<GetContactsDataResponse> =
        await apiNode.patch(`${URL_CONTACTS}/${data?.id}`, data)
      return response?.data
    },
    async deleteContact({id}: {id: string}) {
      const response: AxiosResponse<GetContactsDataResponse> =
        await apiNode.delete(`${URL_CONTACTS}/${id}`)
      return response?.data
    },
    async pinContact({id, pin}: {id: string, pin: boolean}) {
      const response: AxiosResponse<GetContactsDataResponse> =
        await apiNode.post(`${URL_CONTACTS}/${id}/pin`, { value:pin })
      return response?.data
    },
  }
